module.exports = __webpack_public_path__ + "linkedin.png?b66a51592f580d3433491e11a8683def";